import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ChangeCheckoutEntryValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/schemas/forwardings/checkoutEntry/changeCheckoutEntry.schema'

interface UseChangeCheckoutEntryProps {
  forwardingId: string | undefined
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse, ChangeCheckoutEntryValidationSchema>, 'mutationKey' | 'mutationFn'>>
}

export const useChangeCheckoutEntry = ({
  forwardingId,
  options,
}: UseChangeCheckoutEntryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['changeCheckoutEntry', forwardingId],
    mutationFn: (form: ChangeCheckoutEntryValidationSchema) => {
      return privateAxios.post(`/maintenance/forwardings/${forwardingId}/change_checkout_entry`, {
        checkout_entry_type: form.checkout_entry_type.value,
        checkout_entry_attributes: {
          responsible_id: form.responsible.value,
        },
      })
    },
    ...options,
  })
}
